<span class="sm-overflow-tooltip">
  <span
    #trigger
    class="sm-overflow-tooltip__trigger"
    [class.sm-overflow-tooltip__trigger--interactive]="isOverflowing"
    [attr.tabindex]="isOverflowing && focusable ? 0 : null"
    [attr.role]="isOverflowing && focusable ? 'button' : null"
    [attr.aria-label]="isOverflowing && focusable ? text : null"
    [attr.aria-describedby]="tooltipVisible ? tooltipId : null"
    (mouseenter)="handleMouseEnter()"
    (mouseleave)="handleMouseLeave()"
    (focus)="handleFocus()"
    (blur)="handleBlur()"
    (click)="handleTriggerClick()">
    <ng-content></ng-content>
  </span>

  @if (tooltipVisible) {
    <span
      #tooltipPanel
      class="sm-overflow-tooltip__panel"
      [class.sm-overflow-tooltip__panel--ready]="tooltipReady"
      [id]="tooltipId"
      role="tooltip"
      [style.left.px]="tooltipReady ? tooltipLeft : -9999"
      [style.top.px]="tooltipReady ? tooltipTop : -9999">
      {{ text }}
    </span>
  }
</span>
